// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__sTz8_","bigColWidth":"Table_bigColWidth__1iviX","biggerColWidth":"Table_biggerColWidth__Afd7j","row":"Table_row__1bWx_","col":"Table_col__2vdDD"};